import { FC } from "react"

import { DOCDetails } from "./detail-panels"
import { DLMDOC } from "../_models"

type Props = {
  details: DLMDOC
}

const DLMDOCDetailsSection: FC<Props> = ({details}) => {
  return (
  <div className="d-flex flex-row flex-wrap gap-6 mb-4">
    <DOCDetails dlmAppId={0} details={details} />
  </div>
  )
}

export { DLMDOCDetailsSection }